import { useCallback, useMemo } from "react";

import type { LogMarkerKey } from "../lib/extractLogMarker";
import type { JobLogEntry } from "../lib/parseJobLogEvent";

import { collectLogMarkers, isLogVisibleForMarker } from "../lib/extractLogMarker";
import { useCheckboxGroup } from "../schedules/hooks/useCheckboxGroup";

export const useLogMarkerFilter = (lines: readonly JobLogEntry[], key: LogMarkerKey) => {
  const values = useMemo(() => collectLogMarkers(lines, key), [key, lines]);
  const selection = useCheckboxGroup(values, []);
  const selectedValues = useMemo(
    () => values.filter((value) => selection.selected.has(value)),
    [selection.selected, values]
  );
  const matches = useCallback(
    (message: string) => isLogVisibleForMarker(message, key, selection.selected),
    [key, selection.selected]
  );

  return {
    hasValues: values.length > 0,
    isSelected: selection.isSelected,
    matches,
    selectedValues,
    toggle: selection.toggle,
    values,
  };
};
